import Image from 'next/image'
import React, { useEffect, useMemo, useState } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useTranslation } from 'src/utils/i18n'
import { gql } from '@apollo/client'
import { logQuery } from 'src/utils/apollo'

function Index(data) {
  const [isOpen, setIsOpen] = useState(false)
  const [isOpen2, setIsOpen2] = useState(false)
  const { query } = useRouter()
  const { t } = useTranslation('commonAndroid')

  const products = useMemo(() => {
    const list = Array.isArray(data?.data?.data) ? data.data.data : []

    return list
      .filter(row => row.id == 1 || row.id == 5 || row.id == 4)
      .sort((a, b) => parseFloat(a.attributes.renew_price) - parseFloat(b.attributes.renew_price))
  }, [data])

  const [ID, setID] = useState(() => (products[0] ? parseInt(products[0].id) : null))

  useEffect(() => {
    if (products[0]?.id != null) {
      localStorage.setItem('ProductID', products[0].id)
      setID(parseInt(products[0].id))
    }
  }, [query, products])

  if (products.length < 3) {
    return (
      <div className='bg-[#fff] p-10 text-center'>
        <p className='text-[18px] font-[600]'>{t('Purchase New Package')}</p>
        <p className='mt-2 text-[#666]'>Package list unavailable. Please purchase from the website.</p>
      </div>
    )
  }

  // 排序后写回，兼容下方原有 data.data.data[n] 用法
  data.data.data = products

  return (
    <div
      className={` bg-[#fff] Sixmd:border-t-[1px] Local-step Blds:shadow-step Blds:rounded-[10px] ${!isOpen && !isOpen2 ? '' : 'pb-[50px]'
        }`}
    >
      <div className='pt-[40px]'>
        <p className='text-center mt-2 text-[32px] font-[600] xs:text-[22px]'>{t('Purchase New Package')}</p>
        <p className='text-center mt-[20px] text-[16px] xs:text-[14px] font-[600] w-[430px] text-[#2F343C] xs:w-[96%] mx-auto'>
          {t('Want to connect more devices')}
          <br />
          {t('Get another subscription and start monitoring')}
        </p>
      </div>

      <button
        onClick={() => {
          setID(parseInt(data.data.data[0].id)), localStorage.setItem('ProductID', parseInt(data.data.data[0].id))
        }}
        className={`w-[460px] h-[84px] mx-auto rounded-[10px] p-[10px] flex items-center justify-between mt-[20px] xs:w-[96%] ${ID === parseInt(data.data.data[0].id)
          ? 'bg-[#B8F3E6] border-[#fff] border-[1px] bg-1m-1 bg-cover'
          : 'border-[#12D8AB] border-[1px] bg-1m bg-cover'
          }`}
      >
        <div className='flex xs:w-[90%]'>
          <Image alt='android' width={100} height={100} src='/images/android/step/1.png' className='w-[64px] h-[64px]' />

          <div className='xs:w-[80%] grid items-center ml-[12px] xss:h-0'>
            <p className='text-[24px] xs:text-[20px] font-[600] text-[#12D8AB] text-left'>{t('1 month')}</p>
            <p className='text-[18px] xs:text-[16px] text-[#222222] text-left font-[600]'>
              {parseFloat(data.data.data[0].attributes.renew_price)} USD
            </p>
          </div>
        </div>
        <div
          className={`w-[20px] h-[20px] border-[1px] rounded-full flex items-center mr-4 justify-center ${ID === parseInt(data.data.data[0].id)
            ? 'bg-[#12D8AB] border-[#12D8AB] border-[1px]'
            : 'border-[#12D8AB] border-[1px]'
            }`}
        >
          {ID === parseInt(data.data.data[0].id) && (
            <Image
              src='/images/android/step/yes.svg'
              alt='yes'
              width={10}
              height={10}
              className={`w-[12px] h-[12px]`}
            />
          )}
        </div>
      </button>

      <button
        onClick={() => {
          setID(parseInt(data.data.data[1].id)), localStorage.setItem('ProductID', parseInt(data.data.data[1].id))
        }}
        className={`w-[460px] h-[84px] mx-auto rounded-[10px] p-[10px] flex items-center justify-between mt-[10px] xs:w-[96%] ${ID === parseInt(data.data.data[1].id)
          ? 'bg-[#B8F3E6] border-[#fff] bg-3m-1 bg-cover border-[1px]'
          : 'border-[#12D8AB] border-[1px] bg-3m bg-cover'
          }`}
      >
        <div className='flex xs:w-[90%]'>
          <Image alt='android' width={100} height={100} src='/images/android/step/2.png' className='w-[64px] h-[64px]' />

          <div className='xs:w-[80%] grid items-center ml-[12px] xss:h-0'>
            <p className='text-[24px] xs:text-[20px] font-[600] text-[#12D8AB] text-left'>{t('3 months')}</p>
            <p className='text-[18px] xs:text-[16px] text-[#222222] text-left font-[600]'>
              {parseFloat(data.data.data[1].attributes.renew_price)} USD
            </p>
          </div>
        </div>
        <div
          className={`w-[20px] h-[20px] border-[1px] rounded-full flex items-center mr-4 justify-center ${ID === parseInt(data.data.data[1].id)
            ? 'bg-[#12D8AB] border-[#12D8AB] border-[1px]'
            : 'border-[#12D8AB] border-[1px]'
            }`}
        >
          {ID === parseInt(data.data.data[1].id) && (
            <Image
              src='/images/android/step/yes.svg'
              alt='yes'
              width={10}
              height={10}
              className={`w-[12px] h-[12px]`}
            />
          )}
        </div>
      </button>

      <button
        onClick={() => {
          setID(parseInt(data.data.data[2].id)), localStorage.setItem('ProductID', parseInt(data.data.data[2].id))
        }}
        className={`w-[460px] h-[84px] mx-auto rounded-[10px] p-[10px] flex items-center justify-between mt-[10px] xs:w-[96%] ${ID === parseInt(data.data.data[2].id)
          ? 'bg-[#B8F3E6] border-[#fff] bg-12m-1 bg-cover border-[1px]'
          : 'border-[#12D8AB] border-[1px] bg-12m bg-cover'
          }`}
      >
        <div className='flex xs:w-[90%]'>
          <Image alt='android' width={100} height={100} src='/images/android/step/3.png' className='w-[64px] h-[64px]' />

          <div className='xs:w-[80%] grid items-center ml-[12px] xss:h-0'>
            <p className='text-[24px] xs:text-[20px] font-[600] text-[#12D8AB] text-left'>{t('12 months')}</p>
            <p className='text-[18px] xs:text-[16px] text-[#222222] text-left font-[600]'>
              {parseFloat(data.data.data[2].attributes.renew_price)} USD
            </p>
          </div>
        </div>
        <div
          className={`w-[20px] h-[20px] border-[1px] rounded-full flex items-center mr-4 justify-center ${ID === parseInt(data.data.data[2].id)
            ? 'bg-[#12D8AB] border-[#12D8AB] border-[1px]'
            : 'border-[#12D8AB] border-[1px]'
            }`}
        >
          {ID === parseInt(data.data.data[2].id) && (
            <Image
              src='/images/android/step/yes.svg'
              alt='yes'
              width={10}
              height={10}
              className={`w-[12px] h-[12px]`}
            />
          )}
        </div>
      </button>

      <Link
        href={'/android/step/choose-monitored-device'}
        className='w-[278px] h-[40px] bg-[#12D8AB] rounded-[8px] text-white mx-auto flex items-center justify-center mt-[50px] font-[600]'
      >
        {t('BUY NOW')}
      </Link>
    </div>
  )
}

export default Index

export async function getStaticProps() {
  try {
    const { data } = await logQuery({
      query: gql`
      query {
        tsafelyProducts(filters: { tsafely_type_agent: { id: { eq: null } }, platform_type: { eq: "iOS-Cloud" } }) {
          data {
            id
            attributes {
              name
              price
              valid_days
              setup
              renew_price
              img {
                data {
                  id
                  attributes {
                    url
                  }
                }
              }
            }
          }
        }
      }
    `
    })

    return {
      props: {
        data: data?.tsafelyProducts || { data: [] }
      }
    }
  } catch (e) {
    console.error('[pricing getStaticProps]', e?.message || e)

    return {
      props: {
        data: { data: [] }
      }
    }
  }
}
